import './TutorialSkipModal.css'

interface TutorialSkipModalProps {
    onStart: () => void
    onSkip: () => void
}

export function TutorialSkipModal({ onStart, onSkip }: TutorialSkipModalProps) {
    return (
        <div className="tut-skip-modal__overlay">
            <div className="tut-skip-modal">
                <div className="tut-skip-modal__icon">📚</div>
                <h2 className="tut-skip-modal__title">Tutorial starten?</h2>

                <p className="tut-skip-modal__text">
                    Lerne alle Funktionen kennen und erhalte eine Belohnung!
                </p>

                <div className="tut-skip-modal__reward">
                    <span className="tut-skip-modal__reward-icon">🎁</span>
                    <span className="tut-skip-modal__reward-text">+100 💎 Gems</span>
                </div>

                <div className="tut-skip-modal__buttons">
                    <button
                        className="tut-skip-modal__btn tut-skip-modal__btn--start"
                        onClick={onStart}
                    >
                        ✅ JA, LOS GEHT'S!
                    </button>

                    <button
                        className="tut-skip-modal__btn tut-skip-modal__btn--skip"
                        onClick={onSkip}
                    >
                        ⏭️ Überspringen
                    </button>
                </div>

                <p className="tut-skip-modal__hint">
                    Tipp: Du verpasst die Belohnung wenn du überspringst!
                </p>
            </div>
        </div>
    )
}
